import React, {useCallback, useState, useRef} from "react";
import {Button, Icon, Modal, Tooltip, Input} from "antd";
import __i18n from "../../intl/__i18n";
import {REGEX_PATTERNS} from "../../constants/regex";
import {CopyToClipboard} from 'react-copy-to-clipboard';
import './index.css'

type Props = {
  form: any,
  code: string
};

const URLMaker = (props: Props) => {
  const {code} = props;
  const [visible, setVisible] = useState(false);
  const [url, setUrl] = useState("");
  const inputRef = useRef();
  
  const handleCancel = useCallback(() => {
    setVisible(false)
  }, []);
  
  const showModal = useCallback(() => {
    setVisible(true)
  }, []);
  
  const onChangeUrl = (e) => {
    const newUrl = e.target.value;
    if (!!newUrl && REGEX_PATTERNS.URL.test(newUrl)) {
      const separator = (newUrl.indexOf("?") === -1) ? "?" : "&";
      setUrl(newUrl + separator + `r=${code}`)
    }
    else {
      setUrl("")
    }
  };
  
  return (
    <>
      <Tooltip title={__i18n("Make URL address")}>
        <Button type="link" size={`small`} onClick={showModal}>
          <Icon type="link"/>
        </Button>
      </Tooltip>
      
      <Modal
        title={__i18n("Enter valid URL address")}
        visible={visible}
        footer={null}
        className={'url-maker-modal'}
        // onOk={this.handleOk}
        onCancel={handleCancel}
      >
        
        <Input style={{marginBottom: "10px"}} onChange={onChangeUrl}/>
        
        <Input
          ref={inputRef}
          disabled
          suffix={(
            <CopyToClipboard text={url}>
              <Button disabled={!!url ? false : true} className={'suffix'} icon={'copy'}/>
            </CopyToClipboard>
          )}
          value={url}/>
      
      </Modal>
    </>
  )
};

export default URLMaker;